<template>
  <TabbedPortletOpportunity>
    <TabbedPortletHead v-if="hasMultipleTermsConditions">
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.TERMS_AND_CONDITIONS_TAB }"
          @click.prevent="selectTab(tabs.TERMS_AND_CONDITIONS_TAB)">Terms & Conditions</a>
      </li>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.CONSUMER_TERMS_AND_CONDITIONS_TAB }"
          @click.prevent="selectTab(tabs.CONSUMER_TERMS_AND_CONDITIONS_TAB)">Consumer Terms & Conditions</a>
      </li>
    </TabbedPortletHead>
    <TabbedPortletBody>
      <div class="tab-content">
        <TabbedPortletBodyTab :show="selectedTab === tabs.TERMS_AND_CONDITIONS_TAB">
          <div class="fullEditor">
            <Editor
              v-model="$v[validationGroupName].sections.termsAndConditions.$model"
              @blur="$v[validationGroupName].sections.termsAndConditions.$touch()"
              :validator="$v[validationGroupName].sections.termsAndConditions"
              :showDebugger="false"
              :disabled="isCompletedQuote" />
          </div>
        </TabbedPortletBodyTab>
        <TabbedPortletBodyTab :show="selectedTab === tabs.CONSUMER_TERMS_AND_CONDITIONS_TAB">
          <div class="fullEditor">
            <Editor
              v-model="$v[validationGroupName].sections.consumerTermsAndConditions.$model"
              @blur="$v[validationGroupName].sections.consumerTermsAndConditions.$touch()"
              :validator="$v[validationGroupName].sections.consumerTermsAndConditions"
              :showDebugger="false"
              :disabled="isCompletedQuote" />
          </div>
        </TabbedPortletBodyTab>
      </div>
    </TabbedPortletBody>
  </TabbedPortletOpportunity>
</template>

<script>
import Editor from '@/components/_shared/Editor.vue'
import TabbedPortletBody from "@/components/_shared/tabbed-portlet/TabbedPortletBody.vue";
import TabbedPortletHead from "@/components/_shared/tabbed-portlet/TabbedPortletHead.vue";
import TabbedPortletOpportunity from "@/components/_shared/tabbed-portlet-opportunity/TabbedPortletOpportunity.vue";
import TabbedPortletBodyTab from "@/components/_shared/tabbed-portlet/TabbedPortletBodyTab.vue";
import {mapGetters} from "vuex";
import {OPPORTUNITY__BRANDS} from "@/constants";

export default {
  name: 'TabTermsAndConditions',
  inject: ['$v'],
  components: {TabbedPortletBodyTab, TabbedPortletOpportunity, TabbedPortletHead, TabbedPortletBody, Editor },
  data () {
    const TERMS_AND_CONDITIONS_TAB = 'terms-and-conditions-tab'
    const CONSUMER_TERMS_AND_CONDITIONS_TAB = 'consumer-terms-and-conditions-tab'

    return {
      selectedTab: TERMS_AND_CONDITIONS_TAB,
      tabs: {
        TERMS_AND_CONDITIONS_TAB,
        CONSUMER_TERMS_AND_CONDITIONS_TAB,
      }
    };
  },
  computed: {
    ...mapGetters({
      'opportunityData': 'opportunity/opportunity',
    }),
    hasMultipleTermsConditions() {
      return (
        this.opportunityData &&
        OPPORTUNITY__BRANDS.TRAFALGAR === this.opportunityData.properties_opportunity.id_brand
      );
    },
  },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    selectTab (tabName) {
      this.selectedTab = tabName
    },
  },
}
</script>
